import "../sass/child-styles.scss"

import ChildThemeAnimations from "./modules/ChildThemeAnimations";
import DynamicSiteLogo from "./modules/DynamicSiteLogo";
import wpcf_HeaderAppearance from "./modules/HeaderAppearance";

const wpcf_headerAppearance = new wpcf_HeaderAppearance();

if ( ! document.body.classList.contains( "wp-admin" ) ) {
    const childThemeAnimations = new ChildThemeAnimations();
    const dynamicSiteLogo = new DynamicSiteLogo();
}
